import React, { useEffect, useRef } from "react";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import { LICENCE_KEY }
from "../../../constants/charts";

am4core.addLicense(LICENCE_KEY);

export default function QualitativeImpact({
    id,
    title = "QUALITATIVE IMPACT (PORTFOLIO)"
})
{
    const chartRef =
        useRef(null);

    useEffect(() =>
    {
        const chart =
            am4core.create(
                id,
                am4charts.RadarChart);

        chart.padding(
            10,
            10,
            10,
            10);

        chart.innerRadius =
            am4core.percent(5);

        chart.startAngle = -90;
        chart.endAngle = 270;

        chart.data =
        [
            {
                category: "Safety",
                value: 8
            },
            {
                category: "Compliance",
                value: 6
            },
            {
                category: "Operational",
                value: 9
            },
            {
                category: "Financial",
                value: 7
            },
            {
                category: "Reputation",
                value: 8
            },
            {
                category: "Sustainability",
                value: 7
            }
        ];

        //
        // Category Axis
        //

        const categoryAxis =
            chart.xAxes.push(
                new am4charts.CategoryAxis());

        categoryAxis.dataFields.category =
            "category";

        categoryAxis.renderer.grid.template.stroke =
            am4core.color("#d9dde3");

        categoryAxis.renderer.grid.template.strokeOpacity =
            1;

        categoryAxis.renderer.labels.template.fill =
            am4core.color("#555");

        categoryAxis.renderer.labels.template.fontSize =
            11;

        categoryAxis.renderer.minGridDistance =
            30;

        //
        // Value Axis
        //

        const valueAxis =
            chart.yAxes.push(
                new am4charts.ValueAxis());

        valueAxis.min = 0;
        valueAxis.max = 10;
        valueAxis.strictMinMax = true;

        valueAxis.renderer.grid.template.stroke =
            am4core.color("#d9dde3");

        valueAxis.renderer.grid.template.strokeOpacity =
            1;

        valueAxis.renderer.labels.template.fill =
            am4core.color("#888");

        valueAxis.renderer.labels.template.fontSize =
            10;

        //
        // Series
        //

        const series =
            chart.series.push(
                new am4charts.RadarSeries());

        series.dataFields.categoryX =
            "category";

        series.dataFields.valueY =
            "value";

        series.stroke =
            am4core.color("#457bff");

        series.strokeWidth =
            3;

        series.fill =
            am4core.color("#457bff");

        series.fillOpacity =
            0.25;

        series.tooltipText =
            "[bold]{category}[/]\nScore: {valueY}/10";

        //
        // Bullets
        //

        const bullet =
            series.bullets.push(
                new am4charts.CircleBullet());

        bullet.circle.radius =
            5;

        bullet.circle.fill =
            am4core.color("#ffffff");

        bullet.circle.stroke =
            am4core.color("#457bff");

        bullet.circle.strokeWidth =
            3;

        //
        // Animation
        //

        series.hiddenState.properties.opacity = 0;
        series.hiddenState.properties.visible = true;

        chart.cursor =
            new am4charts.RadarCursor();

        chart.cursor.lineY.disabled = true;
        chart.cursor.lineX.disabled = true;

        chartRef.current =
            chart;

        return () =>
        {
            chart.dispose();
        };

    }, [id]);

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",

                overflow: "hidden"
            }}
        >
		<div
				               style={{
				                   fontSize: "12px",
				                   fontWeight: 500,

				                   textTransform: "uppercase",

				                   marginBottom: "16px",

				                   color: "#222"
				               }}
				           >
                {title}
            </div>

            <div
                id={id}
                style={{
                    flex: 1,
                    width: "100%"
                }}
            />
        </div>
    );
}